/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type PlanningProposalsFilterPropertyTypesItem =
  (typeof PlanningProposalsFilterPropertyTypesItem)[keyof typeof PlanningProposalsFilterPropertyTypesItem];

export const PlanningProposalsFilterPropertyTypesItem = {
  APARTMENT_BUILDING: "APARTMENT_BUILDING",
  TOWN_HOUSES: "TOWN_HOUSES",
  DETACHED_HOUSES: "DETACHED_HOUSES",
  DETAIL: "DETAIL",
  COMMERCIAL: "COMMERCIAL",
  INSTITUTIONS: "INSTITUTIONS",
  UNKNOWN: "UNKNOWN",
} as const;
